import { Modal } from "@visiblethread/react-components";
import recalcAnimation from "assets/animations/recalc.json";
import Lottie from "lottie-react";
import React from "react";

import styles from "./RecalcProgressModal.module.scss";

const RecalcProgressModal = () => (
  <Modal show backdrop>
    <Modal.Header>Calculating your business alignment</Modal.Header>
    <Modal.Body>
      <div className={styles.body}>
        <div className={styles.animation}>
          <Lottie animationData={recalcAnimation} loop={true} />
        </div>
        <p className={styles.message}>
          We are re-calculating your business alignment scores across the
          workspace. This usually takes under a minute. Hang tight while we
          finish up.
        </p>
      </div>
    </Modal.Body>
  </Modal>
);

export default RecalcProgressModal;
